import axios from '../axios-init';

export const getMembersById = params => {
    return axios.post(`/member/getMemberById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editMember = params => {
    return axios.post(`/member/editInfo`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getDoctorMembers = params => {
    return axios.post(`/member/getListByLogin`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const invitationRegister = params => {
    return axios.post(`/invitation/inviteUser`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getInvitations = params => {
    return axios.post(`/invitation/invitationList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editInvitationStatus = params => {
    return axios.post(`/invitation/editInvitaStatus`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getDoctorMemberList = params => {
    return axios.post(`/member/getAllUserByLogin`, params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const getGroupList = params => {
    return axios.post(`/group/getList`, params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const deleteGroup = params => {
    return axios.post(`/group/delGroupById`, params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const addGroup = params => {
    return axios.post(`/group/saveOrUpdateGroup`, params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const getGroupById = params=>{
    return axios.post(`/group/getGroupInfoById`,params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const getMemberById = params=>{
    return axios.post(`/member/getMemberById`,params).then(res => {
        return res.data;
    }).catch(error => error)
};


export const getAllMemberList = params=>{
    return axios.post(`/admin/queryUsersInfoList`,params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const editUserStatus = params=>{
    return axios.post(`/admin/modifyUserStatus`,params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const getAdminInvitationList = params=>{
    return axios.post(`/admin/invitationList`,params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const invitationDoctor = params=>{
    return axios.post(`/admin/InvitedDoctor`,params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const getNurseDoctor = params=>{
    return axios.post(`/member/getDoctorInfoByCurrentUser`,params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const getMemberWithGroup = params=>{
    return axios.post(`/group/getGroupAndMemberInfoList`,params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const getDoctorNurse = params=>{
    return axios.post(`/offer/getNurseInfoListByCurrentUser`,params).then(res => {
        return res.data;
    }).catch(error => error)
};

export const getUserBalance = params=>{
    return axios.post(`/member/getMemberBalance`,params).then(res => {
        return res.data;
    }).catch(error => error)
};



// WEBPACK FOOTER //
// ./src/api/memberService.js